import api from './api';
import { buildGatewayDocumentRequest } from '../utils/gatewayDocuments';

const saveRecord = async (method, resource, data, id) => {
  const request = resource === 'master-providers' ? buildGatewayDocumentRequest(data) : data;
  return (await api[method](`/payment-gateway/${resource}${id ? `/${id}` : ''}`, request, request instanceof FormData ? {
    headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000
  } : undefined)).data;
};

const paymentGatewayService = {
  list: async (resource, params) => (await api.get(`/payment-gateway/${resource}`, { params })).data,
  create: (resource, data) => saveRecord('post', resource, data),
  update: (resource, id, data) => saveRecord('put', resource, data, id),
  remove: async (resource, id) => (await api.delete(`/payment-gateway/${resource}/${id}`)).data,
  getMasterProviderOptions: async () => (await api.get('/payment-gateway/master-providers/options')).data
};

export default paymentGatewayService;
